class deductionConfigAddCtrl {
    constructor($scope, httpRequest,$uibModalInstance, logger, sweetalert) {
        const types = ['department_no']
        $scope.param = {
            schemeName: '',
            useScope: ''
        }
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.ok = function ok() {
            if (!$scope.param.schemeName) {
                logger.logError('请输入方案名称！')
                return
            }
            if (!$scope.param.useScope) {
                logger.logError('请选择方案适用范围！')
                return
            }
            httpRequest.post_addDeductionScheme($scope.param).then((res) => {
                if(res.data && res.data.success){
                    $uibModalInstance.close()
                }else{
                    logger.logError(res.data.message)
                }
            })

        }
    }
}

deductionConfigAddCtrl.$inject = ['$scope', 'httpRequest','$uibModalInstance', 'logger', 'sweetalert']

export default deductionConfigAddCtrl



// WEBPACK FOOTER //
// ./src/app/input/basedata/deductionConfig/deductionConfigAddCtrl.js